import React from 'react';
import { motion } from 'framer-motion';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

const GlowText = ({ children, className, color = 'cyan', as = 'h1' }) => {
  const Component = motion[as] || motion.h1;
  
  const glowColors = {
    cyan: 'rgba(34, 211, 238, 0.5)',
    gold: 'rgba(251, 191, 36, 0.5)', 
    purple: 'rgba(192, 132, 252, 0.5)',
    white: 'rgba(255, 255, 255, 0.3)'
  };

  const shadowColor = glowColors[color] || glowColors.cyan;

  return (
    <Component
      className={twMerge('relative z-10 font-bold tracking-tight', className)}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      style={{
        textShadow: `0 0 40px ${shadowColor}, 0 0 80px ${shadowColor}`
      }}
    >
      <span className="relative z-10">{children}</span>
      {/* Subtle ambient backing for readability */}
      <span 
        className="absolute inset-0 blur-xl opacity-40 z-[-1]" 
        aria-hidden="true"
        style={{ color: shadowColor }}
      >
        {children}
      </span>
    </Component>
  );
};

export default GlowText;